import { useCallback, useEffect, useRef, useState } from "react";

export const OTP_COOLDOWN_SECONDS = 2 * 60;

export default function useOtpCountdown(duration = OTP_COOLDOWN_SECONDS) {
  const [secondsLeft, setSecondsLeft] = useState(0);
  const endTimeRef = useRef(0);
  const intervalRef = useRef(null);

  const clear = useCallback(() => {
    if (intervalRef.current) {
      clearInterval(intervalRef.current);
      intervalRef.current = null;
    }
  }, []);

  const start = useCallback(() => {
    clear();
    endTimeRef.current = Date.now() + duration * 1000;
    setSecondsLeft(duration);

    intervalRef.current = setInterval(() => {
      const remaining = Math.ceil((endTimeRef.current - Date.now()) / 1000);
      if (remaining <= 0) {
        clear();
        setSecondsLeft(0);
        return;
      }
      setSecondsLeft(remaining);
    }, 1000);
  }, [clear, duration]);

  useEffect(() => clear, [clear]);

  return { secondsLeft, isCoolingDown: secondsLeft > 0, start };
}

export const formatCountdown = (seconds) => {
  const minute = Math.floor(seconds / 60)
    .toString()
    .padStart(2, "0");
  const second = (seconds % 60).toString().padStart(2, "0");
  return `${minute}:${second}`;
};
